<template>
  <ModulesComponent />
</template>

<script>
// @ is an alias to /src
import ModulesComponent from "@/sections/voiceplus/components/ModulesComponent.vue";
import config from "@/config";

export default {
  name: "Modules",
  components: {
    ModulesComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
